import StickyPanel from './StickyPanel';

export default StickyPanel;